// extracted by css-extract-rspack-plugin
var _1 = "L7xnem0fgQ6gZVjW";
var _2 = "ZVziSij2GZ0CeVyE";
var _3 = "kY2xrQ7EWj4_qajF";
var _4 = "C6wFllVjQCQ48StF";
var _5 = "LYkT_bXqW6wpyo49";
var _6 = "svo6A6h6b2cXhTbh";
var _7 = "Sse7oK7zqDo886Ec";
var _8 = "wrxbeBt7nHIo65kb";
var _9 = "GZezL0bce9EWgOG1";
var _a = "YMIkn4cc0eAjhajZ";
var _b = "H1peyt0gsXIhhnkS";
var _c = "ia5t_geZXk4g773d";
var _d = "BPnXupzTqH0pE2zB";
var _e = "bZIEEqVlll8tyEQn";
var _f = "FCBNhBvPYKlcQmVi";
var _10 = "jz7wLoVeCDcrlTCt";
var _11 = "T43fflgs_SYc2fwV";
var _12 = "ZdpjcGKuI6428Kr3";
var _13 = "w_YpxkWrBI03wKhr";
var _14 = "bUtBReW2_YDVPQpR";
var _15 = "WStceyrorRY9hbZw";
var _16 = "V5wLoNoIirEiTVD0";
var _17 = "ia6MwOCxHskpDEvN";
export { _1 as "bodyCopy0", _2 as "bodyCopy1", _3 as "bodyCopy2", _4 as "buttonBig", _5 as "buttonMedium", _6 as "buttonMicro", _7 as "buttonSmall", _8 as "headline0", _9 as "headline1", _a as "headline2", _b as "headline3", _c as "headline4", _d as "headline5", _e as "headline6", _f as "infoTxt1", _10 as "infoTxt2", _11 as "infoTxt3", _12 as "miniHeader", _13 as "noWrapStyle", _14 as "strongStyle", _15 as "textBase", _16 as "textBasePrimary", _17 as "textBaseSecondary" }
